<template>
  <div
    :class="[
      $.resources_wrap,
      isActive ? $.active : ''
    ]"
    v-tippy="{
      theme: 'assigned-select',
      interactive: tippyInteractive,
      interactiveBorder: 10,
      content: tippyContent,
      boundary: tippyBoundary,
      placement: 'bottom',
      popperOptions: {
        modifiers: {
          flip: {
            boundariesElement: tippyBoundary,
            flipVariationsByContent: true
          },
        },
      }
    }"
    @click="(e) => $emit('onClick', e)"
  >
    <div
      v-for="item in visibleResources"
    >
      <div
        v-if="item.isRest"
        :class="$.rest"
      >
        {{ item.name }}
      </div>
      <div
        v-else
        :class="$.avatar"
        :style="{
          backgroundImage: `url('${item.avatar}')`
        }"
      >
      </div>
    </div>
    <div
      v-if="!resources.length"
      :class="$.avatar"
    >
      <svg-sprite
        name="assigned"
        :size="24"
        :style="{ color: '#999' }"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: 'AssignedSelect',
  props: {
    resources: {
      type: Array,
      default: []
    },
    maxVisible: {
      type: Number,
      default: 2
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visibleResources() {
      if (this.resources.length <= this.maxVisible) {
        return this.resources;
      }

      const visible = this.resources.slice(0, this.maxVisible - 1);
      visible.push({
        name: `+${this.resources.length - this.maxVisible + 1}`,
        isRest: true
      });

      return visible;
    },
    tippyBoundary() {
      return document.querySelector('.page-wrapper');
    },
    tippyInteractive() {
      return this.resources.length > 8;
    },
    tippyContent() {
      if (!this.resources.length || this.isActive) {
        return '';
      }

      const items = this.resources.reduce((acc, res) => {
        const key = res.userId ? 'people' : 'virtual';
        acc[key].push(res);

        return acc;
      }, {
        people: [],
        virtual: []
      });

      const peopleDivider = items.people.length
        ? this.getTooltipDivider('board_people_label')
        : '';

      const virtualDivider = items.virtual.length
        ? this.getTooltipDivider('board_virtual_label')
        : '';

      return `
        <div class="gantt_scroll thumb-spaced">
          ${peopleDivider}
          ${items.people.map(this.getResourceContent).join('')}
          ${virtualDivider}
          ${items.virtual.map(this.getResourceContent).join('')}
        </div>
      `;
    }
  },
  methods: {
    getTooltipDivider(localeType) {
      return `<div class="divider"><div class="label">${__(localeType).toUpperCase()}</div><div class="dash"></div></div>`
    },
    getResourceContent(res) {
      return `
        <div class="resource">
          <div class="avatar" style="background-image: url('${res.avatar}');"></div>
          <div class="name">${res.name}</div>
          <div class="workload">
            <div>${res.workload}</div>
            <div>${res.workloadUnit}</div>
          </div>
        </div>
      `;
    },
  }
}
</script>

<style module="$" src="../less/assignedSelect.less"></style>
